import React from 'react';
import { Box, collapseClasses, Divider, IconButton, List, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GeneralMenu from './GeneralMenu';
import EventMenu from './EventMenu';
import { fechaEventoTexto } from "../../utils/evento";

const collapsedTooltipSx = {
  tooltip: {
    sx: {
      backgroundColor: '#ffffff',
      color: '#9496aa',
      fontSize: '12px',
      fontFamily: 'Bricolage Grotesque',
      textTransform: 'uppercase',
      fontWeight: 600,
      boxShadow: '0px 8px 24px rgba(11, 0, 98, 0.12), 0px 2px 8px rgba(0,0,0,0.08)',
      border: '1px solid rgba(75, 77, 99, 0.1)',
      borderRadius: '6px',
      px: 1.5,
      py: 0.75,
    }
  },
};

const MenuDrawer = ({
  drawerOpen,
  toggleDrawer,
  isEventoRoute,
  isProfileRoute,
  user,
  eventoActual,
  closeMenus,
  eventoId,
  userRole,
  setQROption,
  expandedMenus,
  toggleExpandMenu,
  isAuthenticated,
  unreadCount,
  loginWithRedirect,
  logoutWithRedirect,
  isMobile,
  overlay = false,
  hideCloseButton = false,
}) => {
  const navbarHeight = isMobile ? '56px' : '64px';
  // modo overlay: el drawer se desliza por encima del contenido (mobile o vista pública desktop)
  const overlayMode = isMobile || overlay;

  const handleMenuItemClick = (handler) => {
    if (!isEventoRoute || isMobile) {
      closeMenus();
    }

    if (typeof handler === 'function') {
      handler();
    }
  };

  const getUserAvatar = (usuario, size = 45) => {
    if (!usuario) return null;

    let initials = "";
    if (usuario.nombre || usuario.apellido) {
      initials =
        (usuario.nombre?.charAt(0) || "") +
        (usuario.apellido?.charAt(0) || "");
    } else if (usuario.usuario) {
      initials = usuario.usuario.charAt(0).toUpperCase();
    } else if (usuario.email) {
      initials = usuario.email.charAt(0).toUpperCase();
    } else {
      initials = "U";
    }

    const avatarStyle = {
      width: size,
      height: size,
      borderRadius: "50%",
      backgroundColor: "#3659E3",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: size / 2,
      fontWeight: "bold",
      userSelect: "none",
    };

    return <div style={avatarStyle}>{initials}</div>;
  };

  const handleCloseDrawer = () => {
    toggleDrawer();
  };

  return (
    <>
      {overlayMode && drawerOpen && (
        <div
          onClick={toggleDrawer}
          style={{
            position: 'fixed',
            top: navbarHeight,
            left: 0,
            width: '100vw',
            height: `calc(100vh - ${navbarHeight})`,
            background: 'rgba(0,0,0,0.4)',
            zIndex: 1199,
            transition: 'background 0.3s',
          }}
        />
      )}

      <Box
        className="passgo-menu-drawer"
        sx={{
          position: 'fixed',
          top: navbarHeight,
          left: 0,
          height: `calc(100vh - ${navbarHeight})`,
          backgroundColor: '#F7F6F9',
          color: '#4B4D63',
          zIndex: 1200,
          padding: "20px 16px",
          boxShadow: '0px 1px 3px rgba(0,0,0,0.2)',
          overflowY: 'auto',
          width: isMobile
            ? (drawerOpen ? '85%' : '0px')
            : overlay
              ? (drawerOpen ? '300px' : '0px')
              : (drawerOpen ? '22%' : '64px'),
          transform: overlayMode
            ? (drawerOpen ? 'translateX(0)' : 'translateX(-100%)')
            : 'none',
          overflowX: 'hidden',
          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '3px',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
            }
          },
        }}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          minHeight: '100%',
          boxSizing: 'border-box'
        }}>
          {isEventoRoute && eventoActual ? (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              padding: '8px 0'
            }}>
              <div style={{ display: 'flex', flexDirection: "column", alignItems: 'center', gap: '8px' }}>
                <div style={{ width: !drawerOpen && !isMobile ? "50px" : "60px", height: !drawerOpen && !isMobile ? "50px" : "60px", flexShrink: "0" }}>
                  <Tooltip title={eventoActual?.evento} placement="right" componentsProps={collapsedTooltipSx}>
                    <img
                      src={eventoActual?.attachs?.[0]?.url || "/img_fiesta.jpg"}
                      alt={eventoActual?.evento}
                      style={{
                        width: !drawerOpen && !isMobile ? "50px" : "100%",
                        height: !drawerOpen && !isMobile ? "50px" : "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: '50%'
                      }}
                    />
                  </Tooltip>
                </div>
                {(drawerOpen || isMobile) && (
                  <div className='d-flex flex-column align-items-center'>
                    <p style={{ margin: 0, color: "#4b4d63", fontWeight: '500', textAlign: "center" }}>{eventoActual?.evento}</p>
                    <small>
                      {fechaEventoTexto(eventoActual, "D [de] MMMM YYYY", "")}
                    </small>
                  </div>
                )}
              </div>
              {!hideCloseButton && !isMobile && (
                <IconButton
                  onClick={handleCloseDrawer}
                  sx={{ color: '#4B4D63' }}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </div>
          ) : isProfileRoute && isAuthenticated ? (
            // header para el perfil
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              padding: '8px 0'
            }}>
              <div style={{ display: 'flex', flexDirection: "column", alignItems: 'center', gap: '8px' }}>
                <div style={{ width: !drawerOpen && !isMobile ? "50px" : "80px", height: !drawerOpen && !isMobile ? "50px" : "80px", flexShrink: "0" }}>
                  {getUserAvatar(user, !drawerOpen && !isMobile ? 50 : 80)}
                  {/* <img
                    src={user?.picture || "/default-avatar.png"}
                    alt="Perfil de usuario"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                      borderRadius: '50%'
                    }}
                  /> */}
                </div>
                {(drawerOpen || isMobile) && (
                  <div className='d-flex flex-column align-items-center'>
                    <p style={{ margin: 0, color: "#4b4d63", fontWeight: '500', textAlign: "center" }}>
                      {(user?.nombre + `${" "}` + user?.apellido) || user?.usuario?.split('@')[0]}
                    </p>
                    <small style={{ color: '#666', fontStyle: 'italic' }}>
                      Mi perfil
                    </small>
                  </div>
                )}
              </div>
              {!hideCloseButton && !isMobile && (
                <IconButton
                  onClick={handleCloseDrawer}
                  sx={{ color: '#4B4D63' }}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </div>
          ) : (
            !hideCloseButton && !isMobile && (
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
                marginBottom: '8px'
              }}>
                <IconButton
                  onClick={handleCloseDrawer}
                  sx={{ color: '#4B4D63' }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            )
          )}


          <List component="nav" sx={{ width: '100%', flex: 1 }}>
            {isEventoRoute && eventoActual ? (
              <>
                <Divider
                  sx={{
                    backgroundColor: '#4b4d63',
                    width: '100%',
                    marginBottom: '10px',
                    marginTop: '10px'
                  }}
                />
                <EventMenu
                  drawerOpen={drawerOpen}
                  toggleDrawer={toggleDrawer}
                  eventoId={eventoId}
                  userRole={userRole}
                  setQROption={setQROption}
                  closeMenus={() => handleMenuItemClick()}
                  expandedMenus={expandedMenus}
                  toggleExpandMenu={toggleExpandMenu}
                  eventoActual={eventoActual}
                  keepDrawerOpen={true}
                  isMobile={isMobile}
                  collapse={!drawerOpen && !isMobile}
                />
              </>
            ) : (
              <>
                {isProfileRoute && (
                  <Divider
                    sx={{
                      backgroundColor: '#4b4d63',
                      width: '100%',
                      marginBottom: '5px',
                      marginTop: '5px'
                    }}
                  />
                )}
                <GeneralMenu
                  isMobile={isMobile}
                  collapse={!drawerOpen && !isMobile}
                  isAuthenticated={isAuthenticated}
                  unreadCount={unreadCount}
                  closeMenus={closeMenus}
                  loginWithRedirect={loginWithRedirect}
                  logoutWithRedirect={logoutWithRedirect}
                  isProfileRoute={isProfileRoute}
                />
              </>
            )}
          </List>
        </div>
      </Box>

    </>

  );
};

export default MenuDrawer;